import { render, staticRenderFns } from "./MaterialReceptionG.vue?vue&type=template&id=d1bfacd4"
import script from "./MaterialReceptionG.vue?vue&type=script&lang=js"
export * from "./MaterialReceptionG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports